/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { get } from "lodash";
import { PropTypes } from "prop-types";
import React from "react";
import { AdService } from "../../ad-service";
import { CommentingWidget } from "../commenting-widget";
import "./story-footer.module.css";

export const StoryFooter = ({ story, isInfiniteScrollEnabled, hydrate }) => {
  if (!isInfiniteScrollEnabled && !global.qtLoadedFromShell && !hydrate) {
    return <div id={`story-footer-${get(story, ["id"], "")}`} />;
  }
  return (
    <div>
      <div styleName="ad">
        <AdService adtype="Story-Bottom-Ad" slotId="StoryBottom" />
      </div>
      <div styleName="metype">
        <CommentingWidget story={story} />
      </div>
    </div>
  );
};

StoryFooter.propTypes = {
  story: PropTypes.object,
  isInfiniteScrollEnabled: PropTypes.boolean,
  hydrate: PropTypes.boolean
};
